/* Copyright 2021 VMware, Inc. All rights reserved. VMware Confidential */
import { Component } from "@angular/core";

// @formatter:off
@Component({
    selector: 'summary-grid',
    templateUrl: './summary-grid.component.html',
    styleUrls: ['./summary-grid.component.scss']
})
// @formatter:on
export class SummaryGridComponent {
}
